export enum InputSource {
	Digital = 'DIGITAL',
	Analog = 'ANALOG'
}
